import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { Button, Typography } from '@mui/material';
import { mutations, queries } from 'RestAPIs/rapini';
import { AxiosError } from 'axios';
import FontAwesomeSvgIcon from 'components/shared/FontAwesomeSvgIcon';
import showSnackbar from 'components/shared/Snackbar';
import Tile from 'components/shared/Tile';
import showError from 'components/shared/showError';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export function BalanceBudgetGiftProcedure() {
  const { t } = useTranslation('common');
  const { data: lastLockedMonth } =
    queries.useSecureAdminProceduresLastLockedMonth();
  const currentYear = dayjs(lastLockedMonth?.lastLockedMonth).year();

  const { mutate, isLoading } =
    mutations.useSecureAdminProceduresBalanceBudgetGift();

  const onClick = async () => {
    mutate(
      {},
      {
        onSuccess: () => {
          showSnackbar({
            message: t('balanceBudgetGiftSuccess')
          });
        },
        onError: (e) => {
          showError(e as AxiosError);
        }
      }
    );
  };

  return (
    <Tile title={t('balanceBudgetGiftProcedure')}>
      <Typography
        variant="body2"
        sx={{ fontFamily: 'signikalight!important', whiteSpace: 'pre-wrap' }}
      >
        {t('balanceBudgetGiftExplanation')}
      </Typography>
      <p>
        {t('currentOpenYear')}: {currentYear}
      </p>
      <Button variant="outlined" onClick={onClick} disabled={isLoading}>
        {isLoading && (
          <FontAwesomeSvgIcon
            icon={faSpinner}
            style={{ animation: 'fa-spin 2s infinite linear' }}
            sx={{ mr: 1 }}
          />
        )}
        {t('execute')}
      </Button>
    </Tile>
  );
}
